module.exports = __webpack_public_path__ + "img/mk.385bb5de.svg";